// extracted by mini-css-extract-plugin
export default {"addRewardWrapper":"add-reward_addRewardWrapper__mTmFB","title":"add-reward_title__sJCFC","back":"add-reward_back__z7nlp"};